<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
  <p>{{text}}</p>
</mat-dialog-content>

<div mat-dialog-actions>
  <button type="submit" class="mat-primary" mat-button (click)="close()">关闭</button>
</div>
